import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import {
  DashBoardHoursModel,
  DashBoardMeetingModel,
} from '../shared/config-model';
import {
  DashBoardChatrelModel,
  DashBoardChatteamModel,
  DashBoardEmailModel,
  DashBoardExternalMatterModel,
  DashBoardGroupsandtmsModel,
  DashBoardMatterModel,
  DashBoardNotificationModel,
  DashBoardStorageModel,
  DashBoardSubscriptionModel,
  DashBoardTimesheetModel,
} from './../shared/config-model';

import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { AjaxService } from '../services/ajax.service';
import { HttpService } from '../services/http.service';
import { XmppService } from '../services/xmpp.service';
import { URLUtils } from '../urlUtils';

declare let Strophe: any;
declare let $msg: any;
declare let $pres: any;
declare let $iq: any;
declare let $: any;
declare const Chart: any;

@Component({
    selector: 'app-grid',
    templateUrl: './grid.component.html',
    styleUrls: ['./grid.component.scss'],
    standalone: false
})
export class GridComponent implements OnInit, AfterViewInit, OnDestroy {
  meetingModel: any = DashBoardMeetingModel;
  chatrelModel: any = DashBoardChatrelModel;
  chatteamModel: any = DashBoardChatteamModel;
  emailModel: any = DashBoardEmailModel;
  hoursModel: any = DashBoardHoursModel;
  hiringModel: any = [
    { type: '', count: '' },
    { type: '', count: '' },
  ];
  clientModel: any = [
    { type: '', count: '' },
    { type: '', count: '' },
  ];
  clientM: any[] = [];
  externalModel: any = [
    { type: '', count: '' },
    { type: '', count: '' },
  ];
  storageModel: any = DashBoardStorageModel;
  timesheetModel: any = DashBoardTimesheetModel;
  matterModel: any = DashBoardMatterModel;
  notifyModel: any = DashBoardNotificationModel;
  externalmatterModel: any = DashBoardExternalMatterModel;
  subscriptionModel: any = DashBoardSubscriptionModel;
  groupsandtmsModel: any = DashBoardGroupsandtmsModel;
  relationshipModel: any = { accepted: '', pending: '' };

  pipe = new DatePipe('en-US');
  emailTime: any;
  corporateCount: number = 0;
  ipCount: number = 0;
  dateSet: any = new Date();
  userRole: string = 'TM';

  featuresData: any;
  month: any = [
    'Jan',
    'Feb',
    'March',
    'April',
    'May',
    'Jun',
    'July',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  day: any = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
  ];
  dateMonth: any = this.month[this.dateSet.getMonth()];
  date: any = this.day[this.dateSet.getDate()];
  dateFullYear: any = this.dateSet.getFullYear();
  dateTime: any = this.dateSet.getHours();
  Time = this.dateTime % 12 || 12;
  minute: any = this.dateSet.getMinutes();
  ampm: any = this.dateTime >= 12 ? 'PM' : 'AM';
  cards: any;
  kpiCards: string[] = [];
  mydayCards: string[] = [];
  product = environment.product;

  layout: any = { MYDAY: [], KPI: [] };
  meetingMessage: any;
  notifyMessage: any;
  timesheetModelMessage: any;
  timesheetModelsub: any;
  timesheetModelpen: any;
  flag_pending = false;
  flag_submitted = false;

  time = new Date();
  intervalId: any;
  isAdmin = true;
  firmName: any;
  firmJid = '';
  domain = environment.xmppDomain;
  endUser: any;
  messages: any;
  USERNAME = '';
  PASSWORD: any;
  sendUser: any;
  URL = 'wss://' + this.domain + ':5443/ws';

  unreadcountteam = 0;
  unreadcountclient = 0;
  private teamJids: string[] = [];
  private clientJids: string[] = [];
  unreadNotify = 0;
  clientlistguid: any[] = [];
  teamlistguid: any[] = [];
  unreadcount = 0;
  showUpgrade = false;
  upgradeFeatureKey = '';

  layoutEditMode = false;

  // ========== DRAG & DROP CARD ARRAYS ==========
  leftCards: any[] = [];
  rightCards: any[] = [];
  startDate!: string;
  endDate!: string;
  catsolo: any;

  // Chart instances
  private appointmentChart: any = null;
  private revenueChart: any = null;
  private storageChart: any = null;
  private matterChart: any = null;
  private corpMatterChart: any = null;
  private chartsInitialized = false;

  dashboardModel: any;
  appointmentModel: any;
  dateLabel: any;
  dateMeet: any;
  approximateRevenue: any;
  messageModel: any;
  appointmentTrend: any;
  revenueTrend: any;

  constructor(
    private httpservice: HttpService,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private ajaxService: AjaxService,
    private xmppService: XmppService,
  ) {}

  ngOnInit(): void {
    this.USERNAME = `${URLUtils.get_jid()}@${this.domain}`;
    this.getChatlist();

    this.xmppService.connect(); // no-op if already connected
    this.xmppService.incomingMessage$.subscribe((msg: any) => {
      const body = $(msg).find('body');
      if (!body.length) return;

      const from = $(msg).attr('from');
      if (!from) return;

      // Normalize to bare JID — "guid@domain" without resource
      const bareJid = from.split('/')[0];
      this.increment_count(bareJid);
    });

    const currentYear = new Date().getFullYear();
    const start = new Date(currentYear, 0, 1);
    const today = new Date();
    this.featuresData = localStorage.getItem('features');
    this.catsolo = localStorage.getItem('category');

    this.startDate = start.toLocaleDateString('en-US', {
      month: 'short',
      year: 'numeric',
    });

    this.endDate = today.toLocaleDateString('en-US', {
      month: 'short',
      year: 'numeric',
    });

    this.initializeCardOrder();

    this.httpservice.unreadCount$.subscribe((count) => {
      this.unreadNotify = count;
    });
    this.getUnreadCountFromAPI();

    this.getDashboardLog();
    // this.getChatlist();
    // this.getLayout();
    // this.getMeetingdata();
    // this.getChatrel();
    // this.getChatteam();
    // this.getEmail();
    // this.getHours();
    // this.getHiring();
    // this.getStorage();
    // this.getTimesheet();
    // this.getMatter();
    // this.getSubscription();
    // this.getGroupsandtms();
    // this.getClients();
    // this.getExternal();
    // this.getRelationships();
    // this.getNotify();
    // this.getUnreadCounts();

    if (this.product == 'corporate') {
      this.getExternalMatters();
    }

    var role = localStorage.getItem('role');
    if (role != null) {
      this.userRole = role;
    }

    this.intervalId = setInterval(() => {
      this.time = new Date();
    }, 1000);

    this.sendUser = localStorage.getItem('name');
    this.messages = [];
    this.firmName = URLUtils.get_firmName();
    this.isAdmin =
      URLUtils.get_userid() == null || URLUtils.get_userid() == 'admin'
        ? true
        : false;
    this.PASSWORD = localStorage.getItem('TOKEN');

    // var connection = new Strophe.Connection(this.URL);
    // connection.connect(this.USERNAME, this.PASSWORD, this.onConnect);
    // Strophe.ui = this;
    // Strophe.ui.conn = connection;
  }

  getDashboardLog() {
    this.spinnerService.show();
    this.httpservice
      .getFeaturesdata(URLUtils.getDashboard)
      .subscribe((res: any) => {
        this.spinnerService.hide();
        this.dashboardModel = res?.data;
        this.meetingModel = res?.data.meeting.data.nextMeeting;
        this.dateMeet = res?.data.meeting;
        this.appointmentModel =
          res?.data.upcoming_appointment.data.nextAppointment;
        this.dateLabel = res?.data.upcoming_appointment;
        this.hoursModel = res?.data.hours;
        this.approximateRevenue = res?.data.approximate_revenue;

        this.storageModel = res?.data.storage;
        setTimeout(() => {
          if (this.storageChart) {
            this.updateStorageChart();
          } else {
            this.initStorageChart();
          }
        }, 100);

        this.messageModel = res?.data.messages;
        this.notifyModel = res?.data.notification;

        this.appointmentTrend = res?.data.appointmentTrend;
        setTimeout(() => {
          if (this.appointmentChart) {
            this.updateAppointmentChart();
          } else {
            this.initAppointmentChart();
          }
        }, 100);

        this.revenueTrend = res?.data.revenueTrend;
        setTimeout(() => {
          if (this.revenueChart) {
            this.updateRevenueChart();
          } else {
            this.initRevenueChart();
          }
        }, 100);

        this.matterModel = res.data.matter;
        setTimeout(() => {
          if (this.chartsInitialized) {
            this.updateMatterChart();
          } else {
            this.initMatterChart();
          }
        }, 100);

        this.subscriptionModel = res.data.subscription;

        const hiringData = res?.data?.hiring;
        if (hiringData?.data?.groups?.length) {
          this.hiringModel = hiringData.data.groups.map((g: any) => ({
            type: g.name,
            count: g.memberCount,
            id: g.id,
          }));
        }
      });
  }

  ngAfterViewInit(): void {
    this.loadChartJs().then(() => {
      this.initAllCharts();
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
    this.destroyCharts();
  }

  private loadChartJs(): Promise<void> {
    return new Promise((resolve) => {
      if (typeof Chart !== 'undefined') {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src =
        'https://cdn.jsdelivr.net/npm/chart.js@4.4.0/dist/chart.umd.min.js';
      script.onload = () => resolve();
      document.head.appendChild(script);
    });
  }

  private destroyCharts(): void {
    [
      this.appointmentChart,
      this.revenueChart,
      this.storageChart,
      this.matterChart,
      this.corpMatterChart,
    ].forEach((c) => {
      if (c) {
        try {
          c.destroy();
        } catch (e) {}
      }
    });
  }

  initAllCharts(): void {
    if (this.chartsInitialized) return;
    this.chartsInitialized = true;
    this.initAppointmentChart();
    this.initRevenueChart();
    this.initStorageChart();
    this.initMatterChart();
  }

  initAppointmentChart(): void {
    const canvas = document.getElementById(
      'appointmentChart',
    ) as HTMLCanvasElement;
    if (!canvas) return;

    if (this.appointmentChart) {
      this.appointmentChart.destroy();
    }

    const trend = this.appointmentTrend?.data?.ranges?.['7days'];

    const labels = trend?.x_axis?.labels || [];

    const upcoming =
      trend?.datasets?.find((d: any) => d.name === 'Upcoming')?.data || [];

    const completed =
      trend?.datasets?.find((d: any) => d.name === 'Completed')?.data || [];

    const cancelled =
      trend?.datasets?.find((d: any) => d.name === 'Cancelled')?.data || [];

    const yAxis = trend?.y_axis;

    this.appointmentChart = new Chart(canvas, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Upcoming',
            data: upcoming,
            backgroundColor: '#3b82f6',
            borderRadius: 4,
            barThickness: 10,
          },
          {
            label: 'Completed',
            data: completed,
            backgroundColor: '#22c55e',
            borderRadius: 4,
            barThickness: 10,
          },
          {
            label: 'Cancelled',
            data: cancelled,
            backgroundColor: '#ef4444',
            borderRadius: 4,
            barThickness: 10,
          },
        ],
      },
      options: {
        responsive: true,
        plugins: {
          legend: { display: false },
          tooltip: {
            mode: 'index',
            intersect: false,
          },
        },
        scales: {
          x: {
            grid: { display: false },
            border: { display: false },
          },
          y: {
            grid: { color: '#f3f4f6' },
            border: { display: false },
            beginAtZero: true,
            min: yAxis?.min ?? 0,
            max: yAxis?.max ?? undefined,
            ticks: {
              stepSize: yAxis?.step ?? undefined,
            },
          },
        },
      },
    });
  }
  updateAppointmentChart(): void {
    if (!this.appointmentChart) {
      this.initAppointmentChart();
      return;
    }

    const trend = this.appointmentTrend?.data?.ranges?.['7days'];

    const labels = trend?.x_axis?.labels || [];

    const upcoming =
      trend?.datasets?.find((d: any) => d.name === 'Upcoming')?.data || [];

    const completed =
      trend?.datasets?.find((d: any) => d.name === 'Completed')?.data || [];

    const cancelled =
      trend?.datasets?.find((d: any) => d.name === 'Cancelled')?.data || [];

    const yAxis = trend?.y_axis;

    this.appointmentChart.data.labels = labels;
    this.appointmentChart.data.datasets[0].data = upcoming;
    this.appointmentChart.data.datasets[1].data = completed;
    this.appointmentChart.data.datasets[2].data = cancelled;

    this.appointmentChart.options.scales['y'].min = yAxis?.min ?? 0;
    this.appointmentChart.options.scales['y'].max = yAxis?.max ?? undefined;
    this.appointmentChart.options.scales['y'].ticks.stepSize =
      yAxis?.step ?? undefined;

    this.appointmentChart.update();
  }

  initRevenueChart(): void {
    const canvas = document.getElementById('revenueChart') as HTMLCanvasElement;
    if (!canvas) return;

    if (this.revenueChart) {
      this.revenueChart.destroy();
    }

    const range = this.revenueTrend?.data?.defaultRange || '7days';
    const trend = this.revenueTrend?.data?.ranges?.[range];

    const labels = trend?.x_axis?.labels || [];
    const revenueData = trend?.datasets?.[0]?.data || [];

    const yAxis = trend?.y_axis;
    const currencySymbol = this.revenueTrend?.data?.currency?.symbol || '₹';

    this.revenueChart = new Chart(canvas, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Revenue',
            data: revenueData,
            borderColor: '#14b8a6',
            backgroundColor: 'rgba(20,184,166,0.2)',
            fill: true,
            tension: 0.4,

            pointRadius: 4,
            pointHoverRadius: 5,
            pointBackgroundColor: '#14b8a6',

            clip: false, // ✅ prevents cutting at edges
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,

        layout: {
          padding: {
            top: 10,
            bottom: 10,
          },
        },

        plugins: {
          legend: { display: false },
        },
        scales: {
          x: {
            grid: { display: false },
            border: { display: false },
          },
          y: {
            beginAtZero: true,
            grid: { color: '#f3f4f6' },
            border: { display: false },
            min: yAxis?.min ?? 0,
            max: yAxis?.max ?? undefined,
            ticks: {
              stepSize: yAxis?.step ?? undefined,
              callback: (value: any) => {
                if (value >= 1000) {
                  return currencySymbol + value / 1000 + 'k';
                }
                return currencySymbol + value;
              },
            },
          },
        },
      },
    });
  }
  updateRevenueChart(): void {
    if (!this.revenueChart) {
      this.initRevenueChart();
      return;
    }

    const range = this.revenueTrend?.data?.defaultRange || '7days';
    const trend = this.revenueTrend?.data?.ranges?.[range];

    if (!trend) return;

    const labels = trend?.x_axis?.labels || [];
    const revenueData = trend?.datasets?.[0]?.data || [];

    const yAxis = trend?.y_axis;

    this.revenueChart.data.labels = labels;
    this.revenueChart.data.datasets[0].data = revenueData;

    this.revenueChart.options.scales['y'].min = yAxis?.min ?? 0;
    this.revenueChart.options.scales['y'].max = yAxis?.max ?? undefined;
    this.revenueChart.options.scales['y'].ticks.stepSize =
      yAxis?.step ?? undefined;

    this.revenueChart.update();
  }
  onRevenuePeriodChange(event: any) {
    const value = event.target.value;

    const range = value == 30 ? '30days' : value == 90 ? '90days' : '7days';

    const trend = this.revenueTrend?.data?.ranges?.[range];

    if (!trend) return;

    this.revenueChart.data.labels = trend.x_axis.labels;
    this.revenueChart.data.datasets[0].data = trend.datasets[0].data;

    const yAxis = trend?.y_axis;
    this.revenueChart.options.scales['y'].min = yAxis?.min ?? 0;
    this.revenueChart.options.scales['y'].max = yAxis?.max ?? undefined;
    this.revenueChart.options.scales['y'].ticks.stepSize =
      yAxis?.step ?? undefined;

    this.revenueChart.update();
  }

  initStorageChart(): void {
    const canvas = document.getElementById('storageChart') as HTMLCanvasElement;
    if (!canvas) return;

    if (this.storageChart) {
      this.storageChart.destroy();
    }

    const used = this.storageModel?.data?.usedGB ?? 0;
    const available = this.storageModel?.data?.availableGB ?? 0;

    const badgeColor = this.storageModel?.badge?.color || 'green';

    const colorMap: any = {
      green: '#3b82f6',
      red: '#ef4444',
      yellow: '#f59e0b',
      blue: '#3b82f6',
    };

    const usedColor = colorMap[badgeColor] || '#3b82f6';

    this.storageChart = new Chart(canvas, {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: [used, available],
            backgroundColor: [usedColor, '#e5e7eb'],
            borderWidth: 0,
            hoverOffset: 3,
          },
        ],
      },
      options: {
        responsive: false,
        cutout: '72%',
        plugins: {
          legend: { display: false },
          tooltip: {
            enabled: true,
            callbacks: {
              label: (ctx: any) => {
                const label = ctx.dataIndex === 0 ? 'Used' : 'Available';
                return `${label}: ${ctx.raw} GB`;
              },
            },
          },
        },
      },
    });
  }
  updateStorageChart(): void {
    if (!this.storageChart) {
      this.initStorageChart();
      return;
    }

    const used = this.storageModel?.data?.usedGB ?? 0;
    const available = this.storageModel?.data?.availableGB ?? 0;

    this.storageChart.data.datasets[0].data = [used, available];

    this.storageChart.update();
  }

  initMatterChart(): void {
    const canvas = document.getElementById('matterChart') as HTMLCanvasElement;
    if (!canvas) return;

    if (this.matterChart) {
      this.matterChart.destroy();
    }

    const chartData = this.matterModel?.data?.chartData;

    const labels = chartData?.y_axis?.labels || ['Legal', 'General'];

    const activeData = chartData?.datasets?.find(
      (d: any) => d.name === 'Active',
    )?.data || [0, 0];

    const closedData = chartData?.datasets?.find(
      (d: any) => d.name === 'Closed',
    )?.data || [0, 0];

    const matterRoutes: string[] = [
      '/matter/matter/legalmatter/view',
      '/matter/matter/generalmatter/view',
    ];

    // Tracks which y-axis label index is currently hovered (-1 = none)
    let hoveredLabelIndex = -1;

    // Helper: given a canvas-relative y pixel, return the closest tick index
    // within a 28px band, or -1 if none match.
    const getTickIndexForY = (yScale: any, yPx: number): number => {
      let best = -1;
      let bestDist = Infinity;
      yScale.ticks.forEach((_tick: any, i: number) => {
        const dist = Math.abs(yScale.getPixelForTick(i) - yPx);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return bestDist <= 28 && best >= 0 ? best : -1;
    };

    // Inline plugin: redraws y-axis labels as blue + underlined when hovered
    const matterLabelHoverPlugin = {
      id: 'matterLabelHover',
      afterDraw: (chart: any) => {
        if (hoveredLabelIndex < 0) return;
        const yScale = chart.scales['y'];
        if (!yScale) return;
        const ctx: CanvasRenderingContext2D = chart.ctx;
        const tickY = yScale.getPixelForTick(hoveredLabelIndex);
        const label = String(labels[hoveredLabelIndex] ?? '');
        const font = yScale.options?.ticks?.font;
        const fontSize = font?.size ?? 12;
        ctx.save();
        ctx.font = `${fontSize}px ${font?.family ?? 'sans-serif'}`;
        ctx.fillStyle = '#2563eb'; // blue link colour
        ctx.textAlign = 'right';
        ctx.textBaseline = 'middle';
        const labelX = yScale.left - (yScale.options?.ticks?.padding ?? 4);
        ctx.fillText(label, labelX, tickY);
        // Underline
        const textWidth = ctx.measureText(label).width;
        ctx.beginPath();
        ctx.strokeStyle = '#2563eb';
        ctx.lineWidth = 1;
        ctx.moveTo(labelX - textWidth, tickY + fontSize * 0.6);
        ctx.lineTo(labelX, tickY + fontSize * 0.6);
        ctx.stroke();
        ctx.restore();
      },
    };

    this.matterChart = new Chart(canvas, {
      type: 'bar',
      plugins: [matterLabelHoverPlugin],
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Active',
            data: activeData,
            backgroundColor: '#3b82f6',
            borderRadius: 4,
            barThickness: 10,
          },
          {
            label: 'Closed',
            data: closedData,
            backgroundColor: '#ffab2d',
            borderRadius: 4,
            barThickness: 10,
          },
        ],
      },
      options: {
        indexAxis: 'y',
        responsive: true,
        onHover: (event: any, elements: any[]) => {
          const yScale = this.matterChart?.scales?.['y'];
          if (!yScale || !event?.native) return;
          const rect = (
            event.native.target as HTMLCanvasElement
          ).getBoundingClientRect();
          const x = event.native.clientX - rect.left;
          const y = event.native.clientY - rect.top;
          const inLabelZone = x <= yScale.left;
          const newIndex = inLabelZone ? getTickIndexForY(yScale, y) : -1;
          // Update cursor
          const isHovering = inLabelZone && newIndex >= 0;
          (event.native.target as HTMLElement).style.cursor =
            isHovering || elements.length > 0 ? 'pointer' : 'default';
          // Redraw only when hovered label changes
          if (newIndex !== hoveredLabelIndex) {
            hoveredLabelIndex = newIndex;
            this.matterChart?.update('none');
          }
        },
        onClick: (_event: any, elements: any[]) => {
          if (elements.length > 0) {
            const index = elements[0].index;
            if (matterRoutes[index]) {
              this.categoryRoute(matterRoutes[index]);
            }
          }
        },
        plugins: {
          legend: { display: false },
          tooltip: { mode: 'index', intersect: false },
        },
        scales: {
          x: {
            grid: { display: false },
            border: { display: false },
          },
          y: {
            grid: { display: false },
            border: { display: false },
          },
        },
      },
    });

    // Handle clicks on y-axis label text (Legal / General)
    canvas.addEventListener('click', (event: MouseEvent) => {
      const yScale = this.matterChart?.scales?.['y'];
      if (!yScale) return;
      const rect = canvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      if (x <= yScale.left) {
        const index = getTickIndexForY(yScale, y);
        if (index >= 0 && matterRoutes[index]) {
          this.categoryRoute(matterRoutes[index]);
        }
      }
    });
  }
  updateMatterChart(): void {
    if (!this.matterChart) {
      this.initMatterChart();
      return;
    }

    // Same source as initMatterChart: per-type counts from the API's chartData
    const chartData = this.matterModel?.data?.chartData;

    const activeData = chartData?.datasets?.find(
      (d: any) => d.name === 'Active',
    )?.data || [0, 0];

    const closedData = chartData?.datasets?.find(
      (d: any) => d.name === 'Closed',
    )?.data || [0, 0];

    this.matterChart.data.datasets[0].data = activeData;
    this.matterChart.data.datasets[1].data = closedData;
    this.matterChart.update();
  }

  getUnreadCountFromAPI() {
    this.httpservice
      .sendGetRequest(URLUtils.getNotifications)
      .subscribe((res: any) => {
        const count = res.data.notifications.filter(
          (n: any) => n.status === 'unread',
        ).length;
        this.httpservice.updateUnreadCount(count);
      });
  }

  // getUnreadCounts() {
  //   this.httpservice.sendChatGetRequest(URLUtils.getunreadcount).subscribe((res: any) => {
  //   });
  // }

  getUnreadCount() {
    this.httpservice.sendGetRequest(URLUtils.getNotifications).subscribe({
      next: (res: any) => {
        if (res && res.data && res.data.notifications) {
          this.unreadNotify = res.data.notifications.filter(
            (n: any) => n.status === 'unread',
          ).length;
        } else {
          this.unreadNotify = 0;
        }
      },
      error: () => {
        this.unreadNotify = 0;
      },
    });
  }

  // ========== DRAG & DROP METHODS ==========

  initializeCardOrder() {
    const savedLeftOrder = localStorage.getItem('dashboard_left_order');
    const savedRightOrder = localStorage.getItem('dashboard_right_order');

    if (savedLeftOrder) {
      this.leftCards = JSON.parse(savedLeftOrder);
    } else {
      this.leftCards = [
        { id: 'date', type: 'date', order: 1 },
        { id: 'customContainer', type: 'customContainer', order: 2 },
        { id: 'meeting', type: 'meeting', order: 3 },
        { id: 'clientMessages', type: 'clientMessages', order: 4 },
        { id: 'teamMessages', type: 'teamMessages', order: 5 },
        { id: 'notifications', type: 'notifications', order: 6 },
        { id: 'dataStorage', type: 'dataStorage', order: 10 },
        { id: 'productSubscription', type: 'productSubscription', order: 16 },
        { id: 'submittedTimesheets', type: 'submittedTimesheets', order: 14 },
      ];
    }

    if (savedRightOrder) {
      this.rightCards = JSON.parse(savedRightOrder);
    } else {
      this.rightCards = [
        { id: 'billableHours', type: 'billableHours', order: 1 },
        { id: 'nonBillableHours', type: 'nonBillableHours', order: 2 },
        { id: 'approxRevenue', type: 'approxRevenue', order: 3 },
        { id: 'avgBillingRate', type: 'avgBillingRate', order: 4 },
        { id: 'matters', type: 'matters', order: 5 },
        { id: 'corpMatters', type: 'corpMatters', order: 6 },
        { id: 'newClients', type: 'newClients', order: 7 },
        { id: 'newCounsels', type: 'newCounsels', order: 8 },
        { id: 'newHires', type: 'newHires', order: 9 },
        { id: 'activeMatters', type: 'activeMatters', order: 11 },
        { id: 'totalGroups', type: 'totalGroups', order: 12 },
        { id: 'totalTeamMembers', type: 'totalTeamMembers', order: 13 },
        { id: 'pendingTimesheets', type: 'pendingTimesheets', order: 15 },
        { id: 'relationships', type: 'relationships', order: 17 },
      ];
    }
  }

  removeRightCard(cardId: string) {
    this.rightCards = this.rightCards.filter((card) => card.id != cardId);
    this.saveCardOrder('right');
  }

  dropLeft(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.leftCards, event.previousIndex, event.currentIndex);
    this.saveCardOrder('left');
  }

  dropRight(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.rightCards, event.previousIndex, event.currentIndex);
    this.saveCardOrder('right');
  }

  saveCardOrder(column: string) {
    if (column === 'left') {
      localStorage.setItem(
        'dashboard_left_order',
        JSON.stringify(this.leftCards),
      );
    } else {
      localStorage.setItem(
        'dashboard_right_order',
        JSON.stringify(this.rightCards),
      );
    }
  }

  resetCardOrder() {
    localStorage.removeItem('dashboard_left_order');
    localStorage.removeItem('dashboard_right_order');
    this.initializeCardOrder();
  }

  toggleEditMode() {
    this.layoutEditMode = !this.layoutEditMode;
  }

  getLayout() {
    this.httpservice
      .getFeaturesdata(URLUtils.getLayout)
      .subscribe((res: any) => {
        this.layout = res;
        this.cards = res['cards'];
        this.cards[1]['options'].forEach((item: any, index: number) => {
          this.kpiCards.push(item.name);
        });
      });
  }

  getMeetingdata() {
    this.httpservice
      .getFeaturesdata(URLUtils.getMeeting)
      .subscribe((res: any) => {
        if ((res.error = 'false')) {
          this.meetingModel = res?.data;
        }
        if ((res.error = 'true')) {
          this.meetingMessage = res?.message;
        }
      });
  }

  getChatrel() {
    this.httpservice
      .getFeaturesdata(URLUtils.getChatrel)
      .subscribe((res: any) => {
        this.chatrelModel = res?.data;
      });
  }

  getChatteam() {
    this.httpservice
      .getFeaturesdata(URLUtils.getChatteam)
      .subscribe((res: any) => {
        this.chatteamModel = res?.data;
        this.chatteamModel.client.timestamp = this.pipe.transform(
          new Date(+res.data.client.timestamp),
          'EEE hh:mm a',
        );
        this.chatteamModel.team.timestamp = this.pipe.transform(
          new Date(+res.data.team.timestamp),
          'EEE hh:mm a',
        );
      });
  }

  getEmail() {
    this.httpservice
      .getFeaturesdata(URLUtils.getEmail)
      .subscribe((res: any) => {
        this.emailModel = res?.data;
        this.emailTime = +res.data.timestamp;
        this.emailModel.timestamp = this.pipe.transform(
          new Date(+res.data.timestamp),
          'MMM d, y',
        );
        this.emailModel['time'] = this.pipe.transform(
          new Date(this.emailTime),
          'hh:mm a',
        );
      });
  }

  getHours() {
    this.httpservice
      .getFeaturesdata(URLUtils.getHours)
      .subscribe((res: any) => {
        // this.hoursModel = res?.data;
      });
  }

  getNotify() {
    this.httpservice
      .getFeaturesdata(URLUtils.getnewNotification)
      .subscribe((res: any) => {
        if ((res.error = 'false')) {
          this.notifyModel = res?.data;
          if ((res.error = 'true')) {
            this.notifyMessage = res?.message;
          }
        }
      });
  }

  getHiring() {
    this.httpservice
      .getFeaturesdata(URLUtils.getHiring)
      .subscribe((res: any) => {
        this.hiringModel = res?.data;
      });
  }

  getStorage() {
    this.httpservice
      .getFeaturesdata(URLUtils.getStorage)
      .subscribe((res: any) => {
        this.storageModel = res?.data;
        this.storageModel.currentStorage = res?.data?.currentStorage;
        this.storageModel.balanceStorage = res?.data?.balanceStorage;
        // Update storage chart with real data
        setTimeout(() => this.updateStorageChart(), 100);
      });
  }

  getTimesheet() {
    this.httpservice
      .getFeaturesdata(URLUtils.getTimesheet)
      .subscribe((res: any) => {
        if (res.error == false) {
          this.timesheetModel = res?.data;
          this.timesheetModelsub = res?.data?.submittedDates;
          this.timesheetModelpen = res?.data?.pendingDates;

          if (Object.keys(res.data?.pendingDates).length === 0) {
            this.flag_pending = true;
          }
          if (Object.keys(res.data?.submittedDates).length === 0) {
            this.flag_submitted = true;
          }
        } else if (res.error == true) {
          this.flag_submitted = true;
          this.flag_pending = true;
        }
      });
  }

  getMatter() {
    this.httpservice
      .getFeaturesdata(URLUtils.getMatter)
      .subscribe((res: any) => {
        this.matterModel = res?.data;
        // Re-draw chart with real data; use updateMatterChart so it works
        // whether the chart was already initialized or not yet
        setTimeout(() => this.updateMatterChart(), 100);
      });
  }

  getSubscription() {
    this.httpservice
      .getFeaturesdata(URLUtils.getSubscription)
      .subscribe((res: any) => {
        this.subscriptionModel = res?.data;
      });
  }

  getGroupsandtms() {
    this.httpservice
      .getFeaturesdata(URLUtils.getGroupsandtms)
      .subscribe((res: any) => {
        this.groupsandtmsModel = res?.data;
      });
  }

  getClients() {
    this.httpservice
      .getFeaturesdata(URLUtils.getNewClients)
      .subscribe((res: any) => {
        this.clientModel = res?.data;
        this.clientM = res;
      });
  }

  getExternal() {
    this.httpservice
      .getFeaturesdata(URLUtils.getExternalCounsels)
      .subscribe((res: any) => {
        this.externalModel = res?.data;
      });
  }

  getExternalMatters() {
    this.httpservice
      .getFeaturesdata(URLUtils.getExternalMatters)
      .subscribe((res: any) => {
        this.externalmatterModel = res?.data;
      });
  }

  getRelationships() {
    this.httpservice
      .getFeaturesdata(URLUtils.getDashboardRelations)
      .subscribe((res: any) => {
        this.relationshipModel = res?.data;
      });
  }

  categoryRoute(cat: any) {
    this.router.navigate([cat]);
  }

  categoryRouteGroupName(route: any, groupName: any) {
    this.router.navigate([route], { queryParams: { highlight: groupName } });
  }

  categoryRouteMonthView(route: any, groupName: any, monthDate?: string) {
    if (this.catsolo !== 'solo') {
      this.router.navigate([route], {
        queryParams: {
          highlight: groupName,
          month: monthDate,
        },
      });
    }
  }

  onButtonClick(data: any) {
    const link = `${environment.paymentgatway}renew?useremail=${data.email}&users=${data.user_allowed}`;
    window.open(link);
    history.pushState(null, '', window.location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  onConnect(status: any) {
    if (status == Strophe.Status.CONNECTING) {
      //console.log('Strophe is connecting.');
    } else if (status == Strophe.Status.CONNFAIL) {
      //console.log('Strophe failed to connect.');
    } else if (status == Strophe.Status.DISCONNECTING) {
      //console.log('Strophe is disconnecting.');
    } else if (status == Strophe.Status.DISCONNECTED) {
      //console.log('Strophe is disconnected.');
    } else if (status == Strophe.Status.CONNECTED) {
      //console.log('Strophe is connected.');
      let count = 0;
      var JID: any;
      Strophe.ui.conn.addHandler(Strophe.ui.stanzaHandler, null, 'message');
      Strophe.ui.conn.addHandler(
        function (stanza: any) {
          const isArchived = stanza.querySelector('archived') !== null;
          if (!isArchived) {
            JID = stanza.getAttribute('from');
            count++;
          }
        },
        null,
        'message',
      );
      if (count > 0) {
        this.unreadcount = count;
        this.UpdateUnreadMsg(JID);
      }
      Strophe.ui.conn.addHandler(
        Strophe.ui.onOwnMessage,
        null,
        'iq',
        'set',
        null,
        null,
      );
      Strophe.ui.conn.addHandler(
        Strophe.ui.on_presence,
        null,
        'presence',
        null,
        null,
        null,
      );
      Strophe.ui.conn.send($pres().tree());
    }
  }

  stanzaHandler(msg: any) {
    Strophe.ui.xmlParser(msg);
    return true;
  }

  async xmlParser(msg: any) {
    const JID = msg.getAttribute('from');
    var id = JID.replace(/\.com.*/, '.com');
    this.increment_count(id);
    this.UpdateUnreadMsg(id);
  }

  UpdateUnreadMsg(fromjid: any) {
    let data = { count: 1, fromjid: fromjid, tojid: this.USERNAME };
    this.httpservice
      .sendPostChatRequest(URLUtils.updatemsgcount, data)
      .subscribe((res: any) => {
        //console.log(res);
      });
  }

  increment_count(fromJid: any) {
    // fromJid comes as "guid@domain" format
    if (this.teamJids.includes(fromJid)) {
      this.unreadcountteam++;
    } else if (this.clientJids.includes(fromJid)) {
      this.unreadcountclient++;
    }
  }

  _getChatlist() {
    // debugger;
    this.httpservice
      .sendGetRequest(URLUtils.getChatList)
      .subscribe((res: any) => {
        this.teamlistguid = res.team?.map(
          (email: any) => email + '@' + this.domain,
        );
        this.clientlistguid = res.clients?.map(
          (email: any) => email + '@' + this.domain,
        );
        if (this.teamlistguid || this.clientlistguid) {
          let data = {
            fromjid: [...this.teamlistguid, ...this.clientlistguid],
            tojid: this.USERNAME,
          };
          this.httpservice
            .sendPostChatRequest(URLUtils.getunreadcountlist, data)
            .subscribe((res: any) => {
              if (res) {
                this.unreadcountteam = 0;
                this.unreadcountclient = 0;

                res.forEach((item: any) => {
                  if (this.teamlistguid.includes(item.fromjid)) {
                    this.unreadcountteam += item.count;
                  } else if (this.clientlistguid.includes(item.fromjid)) {
                    this.unreadcountclient += item.count;
                  } else {
                    console.warn('Unknown JID:', item.fromjid);
                  }
                });

                // console.log('FINAL TEAM:', this.unreadcountteam);
                // console.log('FINAL CLIENT:', this.unreadcountclient);
              }
            });
        }
      });
  }

  private fetchUnreadCountsFromMeta(): void {
    const allJids = [...this.teamJids, ...this.clientJids];
    if (!allJids.length) return;

    const payload = {
      user_jid: this.USERNAME,
      chat_jids: allJids,
    };

    this.httpservice
      .sendPostChatRequest(URLUtils.getChatMetaDetails, payload)
      .subscribe((res: any) => {
        const metaList = res?.data || [];

        // Reset counts
        this.unreadcountteam = 0;
        this.unreadcountclient = 0;

        metaList.forEach((meta: any) => {
          const count = meta.unread_count || 0;
          if (!count) return;

          const chatJid = meta.chat_jid;

          if (this.teamJids.includes(chatJid)) {
            this.unreadcountteam += count;
          } else if (this.clientJids.includes(chatJid)) {
            this.unreadcountclient += count;
          }
        });
      });
  }

  getChatlist() {
    this.httpservice
      .sendGetRequest(URLUtils.getChatList)
      .subscribe((res: any) => {
        this.teamJids = (res.team || []).map(
          (g: string) => `${g}@${this.domain}`,
        );
        this.clientJids = (res.clients || []).map(
          (g: string) => `${g}@${this.domain}`,
        );

        // store for increment_count lookup
        this.teamlistguid = this.teamJids;
        this.clientlistguid = this.clientJids;

        this.fetchUnreadCountsFromMeta();
      });
  }

  handleGroupNavigation() {
    if (this.userRole !== 'TM') {
      this.categoryRoute('/groups/view-group');
    } else {
      console.warn('TM role is not allowed to navigate.');
    }
  }
}
